import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { AuthService } from "../../../core/guards/auth/auth.service";
import { ActivatedRoute, Router } from '@angular/router';
import { ActivateService } from '../activate/activate.service';
import { SubscriptionService } from '../../../modules/subscription/subscription.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';import { SubscriptionListComponent } from '../../../modules/subscription/subscriptionList.component';
import { SubscriptionModel } from '../../../modules/subscription/subscription.model';
import { GetUserInfo, LocalDB } from "../../../shared/utils";
import { animate, createDrawable, createMotionPath, createScope, createTimeline, Scope, stagger } from 'animejs';

@Component({
    selector: 'convfact-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    providers: [SubscriptionService],
    standalone: false
})

export class LoginComponent implements OnInit, AfterViewInit, OnDestroy {
    email: string;
    password: string;
    activated: boolean = true;
    uid: string;
    ready: boolean = false;
    loginSpinner = false;
    showNewPassword: boolean = false;
    rememberMe = false;
    loginError = '';

    private networkScope?: Scope;

    subscriptionList: SubscriptionModel[] = [];

    constructor(private authService: AuthService, private activateService: ActivateService, private route: ActivatedRoute,
        private router: Router, public snackBar: MatSnackBar, private subscriptionService: SubscriptionService, public dialog: MatDialog,
        private elRef: ElementRef<HTMLElement>) {

    }

    forgot() {
        this.router.navigate(['/forgot']);
    }

    register() {
        this.router.navigate(['/register']);
    }

    developers() {
        this.router.navigate(['/developers']);
    }

    openDialog(login: boolean): void {
        this.dialog.open(SubscriptionListComponent, {
            data: { login: login }
        })
            .afterClosed().subscribe(result => this.ngOnInit())
    }

    displayError(error: string): void {
        this.loginError = error;
        const options = new MatSnackBarConfig();
        options.duration = 10500;
        this.snackBar.open(error, '', options);
    }

    login(): void {
        LocalDB.RemoveForFiles();
        this.loginError = '';
        this.loginSpinner = true;
        this.authService.login(this.email, this.password).then(
            result => {
                if (result && result.error) {
                    if (result.message) {
                        this.displayError(result.message);
                    } else {
                        this.displayError("Usuario/Contraseña no válidos");
                    }
                    this.loginSpinner = false;

                    return;
                }

                this.subscriptionService.getSubscriptionList()
                    .then(data => {
                        this.loginSpinner = false;
                        let initialModule = "/resume"
                        if (data != null && data.find(f => f.isActive) != null) {
                            initialModule = data.find(f => f.isActive).initialModule;
                        }
                        if (this.authService.redirectAfterLogin != null && this.authService.redirectAfterLogin.length >= 1) {
                            this.authService.redirectAfterLogin = null;
                        }
                        this.router.navigate([this.authService.redirectAfterLogin || initialModule]);
                    })
                    .catch(data => {
                        if (data.message) {
                            this.displayError(data.message);
                        } else {
                            this.displayError("Usuario/Contraseña no válidos");
                        }
                        this.loginSpinner = false;
                    })

            })
            .catch(err => {
                this.loginSpinner = false;
                if (err.message) {
                    this.displayError(err.message);
                } else {
                    this.displayError("Usuario/Contraseña no válidos");
                }
            }
            );
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.uid = params['uid'];
        })

        if (this.uid == undefined) {
            this.ready = true;
        }

        if (this.uid !== undefined) {
            if (this.uid.length === 36) {
                this.activateService.activate(this.uid).then(response => {
                    this.activated = response;
                    this.ready = true;
                    const options = new MatSnackBarConfig();
                    options.duration = 10000;
                    this.snackBar.open("Su cuenta ha sido activada", '', options);
                });
            } else {
                this.router.navigate(['/login']);
            }
        }

    }


    showPassword(input: any): any {
        input.type = input.type === 'password' ? 'text' : 'password';
        this.showNewPassword = !this.showNewPassword;
    }

    ngAfterViewInit(): void {
        this.initNetworkAnimation();
    }

    ngOnDestroy(): void {
        this.networkScope?.revert();
    }

    private initNetworkAnimation(): void {
        try {
            this.networkScope = createScope({
                root: this.elRef,
                mediaQueries: { reduceMotion: '(prefers-reduced-motion: reduce)' }
            }).add(scope => {
                const root = this.elRef.nativeElement;
                const lines = Array.from(root.querySelectorAll<SVGPathElement>('.fct-network__line'));
                const mesh = Array.from(root.querySelectorAll<SVGPathElement>('.fct-network__mesh'));
                const pulses = Array.from(root.querySelectorAll<SVGCircleElement>('.fct-network__pulse'));

                if (scope.matches['reduceMotion']) {
                    root.querySelectorAll<HTMLElement>('.fct-network__hub, .fct-network__node, .fct-network__label, .fct-network__orbit')
                        .forEach(el => { el.style.opacity = '1'; });
                    [...lines, ...mesh].forEach(line => { line.style.strokeDashoffset = '0'; });
                    return;
                }

                createTimeline({ defaults: { ease: 'outQuad' } })
                    .add('.fct-network__hub', { opacity: [0, 1], scale: [0, 1], duration: 500, ease: 'outElastic(1, .6)' })
                    .add(createDrawable(lines), { draw: ['0 0', '0 1'], duration: 650, delay: stagger(140), ease: 'inOutQuad' }, '-=250')
                    .add('.fct-network__node', { opacity: [0, 1], scale: [0, 1], duration: 450, delay: stagger(140), ease: 'outBack(1.6)' }, '-=600')
                    .add('.fct-network__label', { opacity: [0, 1], translateY: [4, 0], duration: 400, delay: stagger(140) }, '-=450')
                    .add(createDrawable(mesh), { draw: ['0 0', '0 1'], duration: 500, delay: stagger(90), ease: 'inOutQuad' }, '-=250')
                    .add('.fct-network__orbit', { opacity: [0, 1], duration: 500 }, '-=400');

                // Latido del hub
                animate('.fct-network__hub', {
                    scale: [1, 1.12, 1],
                    duration: 1800,
                    loop: true,
                    delay: 2200,
                    ease: 'inOutSine'
                });

                // Anillo orbital girando sin cesar alrededor del hub
                animate('.fct-network__orbit', {
                    rotate: 360,
                    duration: 9000,
                    loop: true,
                    ease: 'linear'
                });

                // Ondas de radar emitidas desde el hub
                animate('.fct-network__ping', {
                    r: [14, 40],
                    opacity: [0.55, 0],
                    duration: 2400,
                    loop: true,
                    delay: stagger(800, { start: 1800 }),
                    ease: 'outSine'
                });

                // Dos pulsos por línea, desfasados en el tiempo, flujo continuo hub ↔ nodo
                lines.forEach((line, i) => {
                    const { translateX, translateY } = createMotionPath(line);
                    const baseDelay = 1600 + i * 260;
                    const linePulses = [pulses[i * 2], pulses[i * 2 + 1]];
                    linePulses.forEach((pulse, j) => {
                        if (!pulse) { return; }
                        animate(pulse, {
                            translateX, translateY,
                            scale: [0.4, 1, 0.4],
                            opacity: [0, 1, 1, 0],
                            duration: 1700,
                            loop: true,
                            delay: baseDelay + j * 850,
                            ease: 'inOutSine'
                        });
                    });
                });
            });
        } catch (e) {
            console.warn('No se pudo iniciar la animación del panel de marca', e);
        }
    }

}
